import {
  Card,
  notification
} from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading";
import PageHeaders from "../../components/pageHeaders";
import { API } from "../../config/Api";
import { POST } from "../../utils/apiRequest";
import HorizontalLineLoader from "../components/loader";
import DataTable from "./dataTable";
  
  function ActiveStaffs() {
    const navigate = useNavigate();
    const [form] = useForm();
    const [Notifications, contextHolder] = notification.useNotification();
  
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
  
    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
  
    const [page, setPage] = useState(1);
    const [take, setTake] = useState(30);
    const [meta, setMeta] = useState<any>({});
  
    useEffect(() => {
      getActive();
    }, [page, take]);
  
    const getActive = async () => {
      try {
        setIsLoading2(true);
        let obj = {
          query: '',
          page: page,
          take: take,
        };
        let api = API.GET_ACTIVE_STAFFS;
        const response: any = await POST(api, obj);
        if (response?.status) {
          setData(response?.data);
          setIsLoading(false);
          setMeta(response?.meta);
        } else {
          setData([]);
          setIsLoading(false);
        }
        setIsLoading2(false);
      } catch (err) {
        setIsLoading(false);
        setIsLoading2(false);
      }
    };
    const editUser = (user: any) => {
      try {
        setSelectedItem(user);
        setModalVisible(!modalVisible);
      } catch (err) {
        console.log(err);
      }
    };
  
    const onView = (val: any) => {
      navigate(`/Auth/discountDetails/${val}`, { state: { val } });
    };
    return (
      <div>
        {contextHolder}
        <PageHeaders title={"Active Staffs"} backButton={true} loading={isLoading2}>
        </PageHeaders>
        {isLoading2 ? <HorizontalLineLoader /> : null}
        <div className="screenBox">
          <Card>
            {isLoading ? (
              <Loading />
            ) : (
              <DataTable
                data={data}
                onEdit={(item: any) => editUser(item)}
                onView={(item: any) => onView(item)}
                meta={meta}
                onPageChange={(page: number, pageSize: number) => {
                  setIsLoading2(true);
                  setPage(page);
                  setTake(pageSize);
                }}
              />
            )}
          </Card>
        </div>
      </div>
    );
  }
  
  export default ActiveStaffs;
  